import { withFocusable } from '../../common/Focusable/Focusable';
import { CoreButtonNext as Button } from './CoreButtonNext';
export const CoreButtonNext = withFocusable(Button);
//# sourceMappingURL=index.js.map